export const config = {
  eventGroup: 'js4_gw_pc_20251120',
  name: '剑侠世界4无限官网PC端',
  identify: 'js4',
  eventTags: ['js4', 'ps', 'gw']
};

export default function createTracker(report, getDiffRouteTime) {
  return {
    loadPage: function() {
      report({
        eventName: 'load_page',
        eventDescription: '页面加载(默认上报，页面全部加载完才上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    pageLeave: function() {
      report({
        eventName: 'page_leave',
        eventDescription: '离开页面(默认上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    loadPageStart: function() {
      report({
        eventName: 'load_page_start',
        eventDescription: '页面加载(默认上报，进入页面就上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    /**
     * @param {string} [title] - 首页...关注我们
     */
    clickTopNav: function(title) {
      report({
        eventName: 'click_top_nav',
        eventDescription: '点击顶部通栏',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [label] - 首页、首页侧边、内页侧边
     */
    clickDownloadPC: function(label) {
      report({
        eventName: 'click_download_PC',
        eventDescription: '点击电脑下载',
        eventDataValue: {
          label: label
        },
        types: {
          label: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [label] - 首页、首页侧边、内页侧边
     */
    clickDownloadAndroid: function(label) {
      report({
        eventName: 'click_download_Android',
        eventDescription: '点击安卓下载',
        eventDataValue: {
          label: label
        },
        types: {
          label: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [label] - 首页、首页侧边、内页侧边
     */
    clickDownloadIOS: function(label) {
      report({
        eventName: 'click_download_iOS',
        eventDescription: '点击苹果下载',
        eventDataValue: {
          label: label
        },
        types: {
          label: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 首页、弹框
     */
    clickHongmengDown: function(title) {
      report({
        eventName: 'click_hongmeng_down',
        eventDescription: '点击鸿蒙下载',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 首页、首页侧边、内页侧边
     */
    scanDownloadGame: function(title) {
      report({
        eventName: 'scan_download_game',
        eventDescription: '扫码下载',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    clickGoRecharge: function() {
      report({
        eventName: 'click_go_recharge',
        eventDescription: '点击前往充值'
      });
    },
    /**
     * @param {string} [kinds] - 最新、新闻、公告、活动
     */
    clickJhkbNav: function(kinds) {
      report({
        eventName: 'click_jhkb_nav',
        eventDescription: '点击江湖快讯栏目',
        eventDataValue: {
          kinds: kinds
        },
        types: {
          kinds: checkTypeHOF('string')
        }
      });
    },
    clickJhkbMore: function() {
      report({
        eventName: 'click_jhkb_more',
        eventDescription: '点击江湖快报更多'
      });
    },
    /**
     * @param {string} [title] - 上报文章标题
     */
    clickJhkbNews: function(title) {
      report({
        eventName: 'click_jhkb_news',
        eventDescription: '点击江湖快报的文章',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报标题名称
     */
    clickJhkbLunbotu: function(title) {
      report({
        eventName: 'click_jhkb_lunbotu',
        eventDescription: '点击江湖快报轮播图',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [kinds] - 最新、新闻、公告、活动
     */
    clickJhkbNavInside: function(kinds) {
      report({
        eventName: 'click_jhkb_nav_inside',
        eventDescription: '点击江湖快讯内页栏目',
        eventDataValue: {
          kinds: kinds
        },
        types: {
          kinds: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报文章标题
     */
    clickJhkbDetailsInside: function(title) {
      report({
        eventName: 'click_jhkb_details_inside',
        eventDescription: '江湖快讯内页栏目的文章',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报门派名称
     */
    clickMenpai: function(title) {
      report({
        eventName: 'click_menpai',
        eventDescription: '点击门派按钮',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报图片标题
     */
    clickGlzlLunbotu: function(title) {
      report({
        eventName: 'click_glzl_lunbotu',
        eventDescription: '攻略资料图点击',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [kinds] - 最新、新手、门派、玩法、进阶
     */
    clickGlzlNav: function(kinds) {
      report({
        eventName: 'click_glzl_nav',
        eventDescription: '攻略资料栏目',
        eventDataValue: {
          kinds: kinds
        },
        types: {
          kinds: checkTypeHOF('string')
        }
      });
    },
    clickGlzlMore: function() {
      report({
        eventName: 'click_glzl_more',
        eventDescription: '点击攻略资料更多'
      });
    },
    /**
     * @param {string} [title] - 上报文章标题
     */
    clickGlzlArticle: function(title) {
      report({
        eventName: 'click_glzl_article',
        eventDescription: '攻略资料栏目的文章',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    clickSearchGlzl: function() {
      report({
        eventName: 'click_search_glzl',
        eventDescription: '点击搜索攻略'
      });
    },
    /**
     * @param {string} [kinds] - 最新、新手、门派、玩法、进阶
     */
    clickGlzlNavInside: function(kinds) {
      report({
        eventName: 'click_glzl_nav_inside',
        eventDescription: '攻略资料内页栏目',
        eventDataValue: {
          kinds: kinds
        },
        types: {
          kinds: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报文章标题
     */
    clickGlzlDetailsInside: function(title) {
      report({
        eventName: 'click_glzl_details_inside',
        eventDescription: '攻略资料内页栏目的文章',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 视频、图像、音乐
     */
    clickStzx: function(title) {
      report({
        eventName: 'click_stzx',
        eventDescription: '视听中心点击',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报视频的标题
     */
    clickStzxPlayVideo: function(title) {
      report({
        eventName: 'click_stzx_play_video',
        eventDescription: '点击播放视听中心视频',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    clickStzxChangeVideo: function() {
      report({
        eventName: 'click_stzx_change_video',
        eventDescription: '点击切换视听中心视频'
      });
    },
    /**
     * @param {string} [title] - 上报图片的标题
     */
    clickStzxPicture: function(title) {
      report({
        eventName: 'click_stzx_picture',
        eventDescription: '点击试听中心图像',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报音乐的标题
     */
    clickStzxPlayMusic: function(title) {
      report({
        eventName: 'click_stzx_play_music',
        eventDescription: '点击播放视听中心音乐',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报切换音乐的名称
     */
    clickStzxChangeMusic: function(title) {
      report({
        eventName: 'click_stzx_change_music',
        eventDescription: '点击切换视听中心音乐',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [statusReason] - 返回原因
     * @param {string} [label] - 上报选中的系统：安卓、鸿蒙、苹果、电脑
     * @param {string} [status] - 成功：success 失败：fail|字符串
     */
    clickToReserveGame: function(statusReason, label, status) {
      report({
        eventName: 'click_to_reserve_game',
        eventDescription: '点击立即预约（预约弹窗）',
        eventDataValue: {
          status_reason: statusReason,
          label: label,
          status: status
        },
        types: {
          status_reason: checkTypeHOF('string'),
          label: checkTypeHOF('string'),
          status: checkTypeHOF('string')
        }
      });
    },
    clickToReserve: function() {
      report({
        eventName: 'click_to_reserve',
        eventDescription: '点击首页预约按钮'
      });
    },
    clickKvVideo: function() {
      report({
        eventName: 'click_kv_video',
        eventDescription: '点击KV视频按钮'
      });
    }
  };
}

Number.isInteger =
  Number.isInteger ||
  function(value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
  };

function checkTypeHOF(type) {
  switch (type) {
    case 'int':
      return Number.isInteger;
    case 'float':
      return value => typeof value === 'number' && !Number.isInteger(value);
    case 'boolean':
      return value => typeof value === 'boolean';
    case 'string':
      return value => typeof value === 'string';
    default:
      setTimeout(() => {
        throw new Error('st-report: invalid value type = ' + type);
      }, 0);
      return null;
  }
}
